export default {
  rewards: {
    title: "انعامات",
    claim: "حاصل کریں",
    weeklyCashback: "ہفتہ وار کیش بیک",
    weeklyCashbackDesc: "ہر ہفتے اپنے نقصانات کا کچھ حصہ واپس حاصل کریں۔",
    dailySpin: "روزانہ گھماؤ",
    dailySpinDesc: "بڑے انعامات جیتنے کا موقع پانے کے لیے روزانہ پہیہ گھمائیں۔",
    invitationBonus: "دعوت کا بونس",
    invitationBonusDesc: "دوستوں کو مدعو کریں اور ہر شامل ہونے والے کے لیے انعام حاصل کریں۔",
    rebate: "ری بیٹ",
    rebateDesc: "ہر شرط پر ری بیٹ حاصل کریں، جیت ہو یا ہار۔",
    bannerTitle: "انعامات",
    bannerSubtitle: "ٹاسک مکمل کریں اور شاندار انعامات حاصل کریں!",
    sectionTitle: "آپ کے شاندار انعامات",
    goNow: "ابھی جائیں",
    historyReceived: "کل حاصل شدہ",
    todayReceived: "آج حاصل شدہ",
    cashbackDialog: {
      title: "بیٹ کیش بیک",
      loading: "لوڈ ہو رہا ہے...",
      empty: "کوئی کیش بیک قواعد نہیں",
      level: "درجہ",
      amountRange: "رقم کی حد",
      rewardRate: "انعام کی شرح",
      rewardCap: "انعام کی حد",
    },
    cards: {
      checkin: {
        title: "روزانہ چیک ان",
        subtitle: "روزانہ چیک ان کے لیے لاگ ان کریں",
        description: "کھلاڑی، ہر روز چیک ان کرنا مت بھولیں~",
      },
      cashback: {
        title: "کیش بیک",
        subtitle: "پلیٹ فارم کے ری بیٹ انعامات",
      },
      rescue: {
        title: "بچاؤ بونس",
        subtitle: "3 کیش گیمز کھیلیں",
        description: "دیوالیہ کھلاڑیوں کو بچانے کے لیے فنڈز",
      },
      task: {
        title: "ٹاسک",
        subtitle: "پلیٹ فارم ٹاسک مکمل کریں",
        description: "پلیٹ فارم ٹاسک",
      },
      balance: {
        title: "والٹ",
        subtitle: "روزانہ سود حاصل کریں",
        description: "پلیٹ فارم والٹ",
      },
      loan: {
        title: "قرض بونس",
        subtitle: "آسانی سے قرض لیں",
        description: "پلیٹ فارم قرض",
      },
    },
    checkIn: {
      dailySignIn: "روزانہ چیک ان",
      totalRewards: "کل انعامات",
      headlineDaysBefore: "",
      headlineDaysAfter: "دن کے لیے چیک ان کریں،",
      headlineTailCumulative: "ایک دن چھوٹنے سے کوئی فرق نہیں پڑتا۔",
      headlineTailDate: "ایک دن چھوٹنے پر اس دن کا انعام ضائع ہو جائے گا۔",
      headlineCumulative: "{days} دن چیک ان کریں اور بڑا انعام جیتیں، ایک دن چھوٹنا کوئی مسئلہ نہیں۔",
      headlineDate: "{days} دن چیک ان کریں، ایک دن چھوٹنے پر اس دن کا انعام ضائع ہو جائے گا۔",
      headlineEmpty: "انعامات جیتنے کے لیے چیک ان کریں",
      title: "چیک ان",
      modeCumulative: "مجموعی چیک ان",
      modeDate: "تاریخ چیک ان",
      rewards: "انعامات",
      signedIn: "چیک ان ہو چکا",
      day: "دن {n}",
      loading: "لوڈ ہو رہا ہے...",
      empty: "کوئی فعال چیک ان سرگرمی نہیں۔",
      btnCheckIn: "چیک ان",
      btnSigned: "ہو گیا",
      btnLocked: "لاک شدہ",
      claimSuccess: "چیک ان کامیاب، انعام {amount} {currency} جمع ہو گیا",
      claimFailed: "چیک ان ناکام",
      alreadySigned: "آپ آج پہلے ہی چیک ان کر چکے ہیں",
      notLogin: "براہ کرم پہلے لاگ ان کریں",
    },
  },
};
